import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { publicAxios } from '../api';

const initialState = {
  polites: [],
  status: 'idle',
  error: null,
};

export const fetchPolite = createAsyncThunk('polites/fetchPolite', async () => {
  const response = await publicAxios.get('/api/politecs');
  return response.data.data.politecs;
});

const politeSlice = createSlice({
  name: 'polites',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolite.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPolite.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.polites = action.payload;
      })
      .addCase(fetchPolite.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export default politeSlice.reducer;